export default "__VITE_ASSET__DuSE9sAz__"